import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
//import { Link } from "react-router-dom";

import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import OPWBreadcrumb from 'components/breadcrumb.js';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {
	SessionChangeModal,
	//,getTimezoneOffset
} from './sessionChangeModal.js';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { CheckAuth } from 'pages/auth/actions.js';
//import Loading from 'components/loading.js'
import Header from 'components/header.js';
import { validateAllFields } from './validation.js';

import { Weigher } from 'components/weighers/weigher.js'; //:UNDO:

import 'react-datepicker/dist/react-datepicker.css';
import Footer from 'components/footer.js';
import {
	actionFetchSessionDetail,
	actionUpdateSession,
	actionInsertSession,
	actionCloseSession,
	actionFetchWeighers,
} from 'pages/sessionManagement/actions.js';
import { ClientSessionSelect } from 'components/clientSessionSelect/clientSessionSelect.js';
import { SessionFilteredList } from './sessionFilteredList.js';
import {
	//actionResetSessionIds,
	actionFetchSessionIds,
} from 'components/clientSessionSelect/sessionSelect/actions.js';
import {
	actionSetMessage,
	actionResetMessages,
} from 'components/messages/actions.js';

import addSeconds from 'date-fns/addSeconds';
import {
	// sub controls for this page
	ShowOpenSessionsOnly,
} from './controls.js';
import { SessionDetail } from './sessionDetails.js';

//import { formatInTimeZone } from 'components/utils/dateLib.js';
import differenceInSeconds from 'date-fns/differenceInSeconds';
import {
	//toDate,
	zonedTimeToUtc,
	utcToZonedTime,
	format,
	getTimezoneOffset,
} from 'date-fns-tz';
import {
	AiOutlineEdit,
	//AiOutlineCloseCircle,
	//AiOutlinePlusCircle,
	AiFillPlusCircle,
} from 'react-icons/ai';
import { actionFetchWeigherIds } from 'components/weighers/actions.js';

//const TITLE = 'Session management'
const BC = OPWBreadcrumb;

export const SessionManagement = (props) => {
	/**
	 *
	 *
	 */

	const sessionIds = useSelector((state) => state.sessionIds);
	const clientId = useSelector((state) => state.clientId);

	const [sessionChangeModalShow, setSessionChangeModalShow] = useState(false);
	const [sessionDetailShow, setSessionDetailShow] = useState(false);
	const [addingNewSession, setAddingNewSession] = useState(false); //helps to display fields when there is no real session rtecorded yet - interum state
	const [modalExitWithoutSavingShow, setModalExitWithoutSavingShow] =
		useState(false);
	const [modalExitWithoutSavingData, setModalExitWithoutSavingData] = useState(
		{}
	);
	const [values, setValues] = useState({});
	const [valMsg, setValMsg] = useState('');
	const [modified, setModified] = useState(false);
	const [showOpenSessionsOnly, setShowOpenSessionsOnly] = useState(false);
	const [msessionId, setMsessionId] = useState(null); // the ID of the session. this is independent to the store sessionId used by the rest of the system.
	const [openSessions, setOpenSessions] = useState([]);
	const [haveOpenSessions, setHaveOpenSessions] = useState(false);
	const [defaultTimezone, setDefaultTimezone] = useState('Australia/Brisbane');
	const [lastSessionTimezone, setLastSessionTimezone] = useState('');
	const [species, setSpecies] = useState('Cattle');

	const [loading, setLoading] = useState(false);

	const cols = { lhs: 4, rhs: 8 };
	const controlStyle = { width: '20em' };
	const dispatch = useDispatch();

	const showMessage = useCallback(
		(data) => dispatch(actionSetMessage(data)),
		[dispatch]
	);
	const setSessionLoading = (status) => {}; //empty function

	const reloadSessionIds = useCallback(
		() => dispatch(actionFetchSessionIds(clientId, true, setSessionLoading)),
		[dispatch, clientId]
	);

	/**
	 * Start a new session - this just sets up the blank form for the user
	 * to enter the new session data.
	 *
	 * Keep all times as date object in local time. Incoming/outgoing are parsed to string. server to use utc only
	 */
	const handleNewSessionController = async () => {
		setAddingNewSession(true); //show the controls
		/*
		First check is a session is open. If a session is open then we display a modal asking to
		close before
		*/
		// if (haveOpenSessions){// display the modal
		// 	setSessionChangeModalShow(true);
		// } else {
		await handleInitiateNewSessionData(new Date());
		setSessionDetailShow(true);
		// }
	};

	const handleInitiateNewSessionData = async (sessionOpenTimeObj) => {
		console.log('sessionOpenTimeObj', sessionOpenTimeObj);

		const resp = await actionFetchWeighers(clientId, showMessage, setLoading);
		let tempTimezone = defaultTimezone;
		let tempSpecies = species;
		let tempSelectedWeighers = [];
		if (resp && resp.length === 1) {
			// only select default if only one unit
			tempTimezone = resp[0].defaultTimezone;
			tempSpecies = resp[0].Species;
			tempSelectedWeighers = [resp[0].WeigherID];
		}

		const newBits = {
			newSession: true,
			species: tempSpecies,
			timezone: tempTimezone,
			sessionStartObj: sessionOpenTimeObj,
			selectedWeighers: tempSelectedWeighers,
			clientWeighers: resp,
			...(openSessions.length > 0
				? { displayUnits: openSessions[0].displayUnits }
				: {}),
			isYardWeights: false,
		};
		setValues(newBits);
	};

	/**
	 * HandleCloseOpenSessions
	 * Close all open sessions for the selected weigherid's
	 *
	 */

	const handleCloseOpenSessions = async (
		openSessions,
		sessionCloseTimeObj,
		reloadAfter
	) => {
		console.log(
			'handleCloseOpenSessions() sessionCloseTimeObj=',
			sessionCloseTimeObj
		);
		dispatch(actionResetMessages());
		for (const session of openSessions) {
			//05/10/2021 I'm not sure what the code below was supposed to actually do, but it was causing issues when daylight savings comes in and
			// the start of the session is prior to daylight savings and the end after. It was causing an overlap between the old and new sessions.
			// So all that is happening below is that I subtract the current session closing time offset from UTC to convert the closing time to
			// UTC format.

			//using offsetTzSec is unreliable here as sometimes a session was not loaded before closeing
			//const sessionObjectStart = utcToZonedTime(openSessions[i].sessionStartUtc, openSessions[i].timezone);
			//offset UTC to local + local to SessionTz
			//const offsetSec = (sessionObjectStart.getTimezoneOffset() * 60) + differenceInSeconds(new Date(openSessions[i].sessionStartUtc), sessionObjectStart)
			const offsetSec = sessionCloseTimeObj.getTimezoneOffset() * 60;
			if (sessionCloseTimeObj !== null && sessionCloseTimeObj !== undefined) {
				const sessionEndObjUtc = addSeconds(sessionCloseTimeObj, offsetSec);
				await actionCloseSession(
					session.SessionID,
					format(sessionEndObjUtc, 'yyyy-MM-dd HH:mm:ss', {}),
					clientId,
					setLoading,
					reloadAfter,
					showMessage,
					reloadSessionIds
				);
			}
		}
	};

	useEffect(() => {
		/*
		If the user changes the timezone mid session then we need to recalc the offsets so the submit to server is correct
		*/
		if (values.sessionStartUtc !== undefined) {
			const sessionObjectStart = utcToZonedTime(
				values.sessionStartUtc,
				values.timezone
			);
			//const offset = (sessionObjectStart.getTimezoneOffset() * 60) + differenceInSeconds(new Date(values.sessionStartUtc), sessionObjectStart);
			//setOffsetTzSec(offset);

			const startChangesObj = {
				sessionStartObj: sessionObjectStart,
			};
			let endChangesObj = {};
			if (values.sessionEndUtc !== null && values.sessionEndUtc !== undefined) {
				const sessionObjectEnd = utcToZonedTime(
					values.sessionEndUtc,
					values.timezone
				);
				endChangesObj = {
					sessionEndObj: sessionObjectEnd,
				};
			}
			setValues((values) => ({
				...values,
				...startChangesObj,
				...endChangesObj,
			}));
		}
	}, [values.timezone, values.sessionEndUtc, values.sessionStartUtc]);

	useEffect(() => {
		async function fetchData() {
			dispatch(actionResetMessages());
			const resp = await actionFetchSessionDetail(
				msessionId,
				clientId,
				showMessage,
				setLoading
			);
			//setValues(resp);

			const clientWeighers = await actionFetchWeighers(
				clientId,
				showMessage,
				setLoading
			);
			const newBits = {
				...resp,
				clientWeighers: clientWeighers,
			};

			setValues(newBits);
		}

		if (msessionId > 0) {
			setValues({});
			setLoading(true);
			fetchData();
		}
	}, [msessionId, clientId, setLoading, dispatch, showMessage]);

	useEffect(() => {
		/**
		 * default time zones for new sessions
		 * Use last open session first otherwise use the weigher.
		 */
		if (lastSessionTimezone !== '') {
			setDefaultTimezone(lastSessionTimezone);
		}
	}, [lastSessionTimezone]);

	useEffect(() => {
		/**
		 * getting open sessions for this weigher.
		 * There should only be one open session but this code is written to handle multiple
		 * open sessions. When a session is closed it will close ALL open sessions to get
		 * integrity back to normal.
		 */
		const openSet = sessionIds.filter((session) => {
			if (!session.isOpen) return false;

			//we only want open sessions for the selected weighers
			if (Array.isArray(values.selectedWeighers)) {
				for (const wid of session.weighers) {
					if (values.selectedWeighers.includes(wid)) return true;
				}
				return false;
			} else if (msessionId) {
				//are we looking for just one session?
				return session.SessionID === msessionId;
			}
			//we want the list of open session regardless of weigher
			return true;
		});

		if (openSet.length > 0) {
			// a session is open for this weigher
			setOpenSessions(openSet);
			setLastSessionTimezone(openSet[0].timezone);
			setHaveOpenSessions(true);
			//setStatus('session-open')
		} else {
			setOpenSessions([]);
			setHaveOpenSessions(false);
		}

		//now get last session for first weigher selected weigher
		let firstWeigher = -1;
		if (values.selectedWeighers?.length > 0) {
			firstWeigher = values.selectedWeighers[0];
		}
		const sessionsThisWeigher = sessionIds.filter((session) => {
			return session.Weigher === Number(firstWeigher);
		});
		let lastSession = null;
		if (sessionsThisWeigher.length > 0) {
			for (let i = sessionsThisWeigher.length - 1; i >= 0; i--) {
				const startObj = new Date(sessionsThisWeigher[i].sessionStartUtc);
				if (
					lastSession === null ||
					startObj.getTime() > lastSession.startObj.getTime()
				) {
					lastSession = {
						...sessionsThisWeigher[i],
						...{ startObj: startObj },
					};
				}
			}
		}
		if (lastSession !== null) {
			setLastSessionTimezone(lastSession.timezone);
		}
	}, [sessionIds, msessionId, values]);

	/** callback from ModalExitWithoutSaving  */
	const handleModalExitWithoutSaving = (data) => {
		setModalExitWithoutSavingData({});
		//evt.persist()
		console.log('handleModalExitWithoutSaving', data);
		switch (data.btnId) {
			case 'cancelExitBtn':
				console.log('cancelling session change');
				break;
			case 'loseChangesBtn':
				console.log('setting msessionId', data.data.msessionId);
				setMsessionId(data.data.msessionId);
				setModified(false);
				break;
			default:
		}
	};

	/**
	 * When form settings are modified by the user, the form values are updated in the state 'values'
	 * @param {*} evt
	 */
	const handleChange = (evt) => {
		try {
			evt.persist();
		} catch (error) {
			//do nothing - need this to spoof a event without the persist method
		}

		setModified(true);
		switch (evt.target.type) {
			case 'select-one':
			case 'text':
				setValues((values) => ({
					...values,
					[evt.target.id]: evt.target.value,
				}));
				//setChanged()
				break;
			default:
		}
	};

	const handleSessionEditBtn = (sessionId) => {
		if (modified) {
			setModalExitWithoutSavingData({ msessionId: sessionId }); // set data - pass to callback
			setModalExitWithoutSavingShow(true); //callback passes to handleModalExitWithoutSaving
		} else {
			// no modified so allow change with ack.
			setMsessionId(sessionId);
		}
		setSessionDetailShow(true);
	};

	const handleSessionCloseBtn = (sessionId) => {
		//an individual close session has been clicked
		console.log('handleSessionCloseBtn()', sessionId);
		setMsessionId(sessionId);
		setSessionChangeModalShow(true);
	};
	const handleSubmit = async (evt) => {
		//evt.persist()
		evt.preventDefault();
		dispatch(actionResetMessages());
		/**
		 * step #1 - validate form data before doing anything else.
		 */
		setValMsg('');

		if (!values.isYardWeights) {
			const valResult = validateAllFields(values);
			if (!valResult.valid) {
				setValMsg(valResult.msg);
				return;
			}
		} else if (values.SessionName.length < 1) {
			setValMsg('Session name not set');
			return;
		}

		//start by adding the difference between the browser tz and the user defined tz (selected in session setup) as they could be different
		const userTZOffeset = getTimezoneOffset(
			values.timezone,
			values.sessionStartObj
		);
		const browserTZOffeset =
			values.sessionStartObj.getTimezoneOffset() * -60000; // getTimezoneOffset (values.sessionStartObj.tz(), aDate);
		let offsetSec = (browserTZOffeset - userTZOffeset) / 1000;
		values.sessionStartObj = addSeconds(values.sessionStartObj, offsetSec);
		//Now work out the UTC time - this is purely for getting the string representation of the
		//UTC time. If you actually look at the sessionStartObjUtc object after the offset it will still be in the
		//browser TZ and so will "appear" wrong.
		offsetSec = values.sessionStartObj.getTimezoneOffset() * 60;
		const sessionStartObjUtc = addSeconds(values.sessionStartObj, offsetSec);
		let sessionEndUtcF = null;
		if (values.sessionEndObj !== null && values.sessionEndObj !== undefined) {
			const sessionEndObjUtc = addSeconds(values.sessionEndObj, offsetSec);
			sessionEndUtcF = format(sessionEndObjUtc, 'yyyy-MM-dd HH:mm:ss', {});
		}

		/**
		 * If this is part of a new session workflow and there are open sessions
		 * then we need to do some closing first
		 *
		 * Check and act on closing any old open sessions
		 *  - close time is 1 sec before new session open time
		 *
		 */

		if (haveOpenSessions && addingNewSession) {
			console.log('values.sessionStartObj=', values.sessionStartObj);
			const sCloseObj = addSeconds(values.sessionStartObj, -1); // close 1 sec before new session start
			console.log('start closing sessions');
			await handleCloseOpenSessions(openSessions, sCloseObj, false); //no reload after as we are adding after this
			console.log('end closing sessions');
		}

		/**
		 * some housekeeping to set UI flage etc
		 *
		 */

		const isUpdate = 'SessionID' in values; //check if key exists - new session will NOT have this key
		setModified(false); //reset flags
		setAddingNewSession(false); // reset flags
		setSessionDetailShow(false); // close the detail window

		/**
		 * Build some data elements to be passed to the server as an api package
		 */

		const commonData = {
			SessionName: values.SessionName,
			Head: values.Head,
			BreedType: values.BreedType,
			Sex: values.Sex,
			Size: values.Size,
			Age: values.Age,
			Paddock: values.Paddock,
			Attractant: values.Attractant,
			WoolGrowth: values.WoolGrowth,
			displayUnits: values.displayUnits,
		};
		if (!values.isYardWeights) {
			//need below to check overlapping sessions
			commonData.sessionStartUtc = format(
				sessionStartObjUtc,
				'yyyy-MM-dd HH:mm:ss',
				{}
			);
			commonData.sessionEndUtc = sessionEndUtcF;
			commonData.timezone = values.timezone;
			commonData.weighers = values.selectedWeighers;
		}
		if (isUpdate) {
			// modified session data - user is editing an existing session not creating a new one
			const updateData = {
				SessionID: values.SessionID,
			};
			//:UNDO:
			/**
			 * :TODO: the close sessions and insert session needs to be sequential and remove 3 sec waits.
			 * the response from the close is occasionally coming after the insert has been sent.
			 */

			await dispatch(
				actionUpdateSession(
					{ ...commonData, ...updateData },
					clientId,
					setModified,
					showMessage,
					reloadSessionIds
				)
			);
		} else {
			//is insert - new session
			const insertData = {
				//:TODO: SessionStart DEPRECIATED
				Client: clientId,
			};
			//:UNDO:
			console.log('start insert');
			await actionInsertSession(
				{ ...commonData, ...insertData },
				setModified,
				showMessage,
				reloadSessionIds
			);
			console.log('end insert');
			//dispatch(actionInsertSession({ ...commonData, ...insertData }, setModified))
		}
		//dispatch(actionUpdateSession(values))	// reload session data after changes
	};

	const handleSessionStartObjChange = (dateObj) => {
		//evt.persist()
		console.log('handleSessionStartObjChange() dateObj', dateObj);
		const newBits = { sessionStartObj: dateObj };
		setValues((values) => ({ ...values, ...newBits }));
		setModified(true);
	};

	const handleSessionEndObjChange = (dateObj) => {
		//evt.persist()
		const newBits = { sessionEndObj: dateObj };
		setValues((values) => ({ ...values, ...newBits }));
		setModified(true);
	};

	const masterProps = {
		//set up here to pass to lots of sub components to save retyping lots of variables
		addingNewSession: addingNewSession,
		setAddingNewSession: setAddingNewSession,
		clientId: clientId,
		cols: cols,
		controlStyle: controlStyle,
		defaultTimezone: defaultTimezone,
		setDefaultTimezone: setDefaultTimezone,
		handleChange: handleChange,
		handleCloseOpenSessions: handleCloseOpenSessions,
		//handleFilteredChange: handleFilteredChange,
		handleInitiateNewSessionData: handleInitiateNewSessionData,
		handleNewSessionController: handleNewSessionController,
		handleModalExitWithoutSaving: handleModalExitWithoutSaving,
		handleSessionStartObjChange: handleSessionStartObjChange,
		handleSessionEndObjChange: handleSessionEndObjChange,
		handleSessionCloseBtn: handleSessionCloseBtn,
		handleSessionEditBtn: handleSessionEditBtn,
		handleSubmit: handleSubmit,
		haveOpenSessions: haveOpenSessions,
		loading: loading,
		modalExitWithoutSavingData: modalExitWithoutSavingData,
		modalExitWithoutSavingShow: modalExitWithoutSavingShow,
		modified: modified,
		setModified: setModified,
		msessionId: msessionId,
		openSessions: openSessions,
		setModalExitWithoutSavingShow: setModalExitWithoutSavingShow,
		setSessionChangeModalShow: setSessionChangeModalShow,
		setSessionDetailShow,
		setShowOpenSessionsOnly: setShowOpenSessionsOnly,
		setValues: setValues,
		sessionChangeModalShow: sessionChangeModalShow,
		sessionIds: sessionIds,
		showOpenSessionsOnly: showOpenSessionsOnly,
		values: values,
		valMsg: valMsg,
		species: species,
		setSpecies: setSpecies,
	};

	// now paint the page
	if (!addingNewSession && !msessionId > 0) {
		return <Template {...masterProps} />;
	} else if (sessionDetailShow) {
		// show the session details form
		return <SessionDetail {...masterProps} />;
	} else {
		return <Template {...masterProps} />;
	}
};

const Template = (props) => {
	const {
		addingNewSession,
		sessionIds,
		//loading,
		handleSubmit,
		showOpenSessionsOnly,
		setShowOpenSessionsOnly,
		handleSessionCloseBtn,
		handleSessionEditBtn,
		msessionId,
		clientId,
		controlStyle,
		handleNewSessionController,
	} = props;

	const [showWeigherModalPulse, setShowWeigherModalPulse] = useState(false);
	const resetShowWeigherModalPulse = () => {
		setShowWeigherModalPulse(false);
	}; //workaround as setTimout cannot call with parameter
	const handleShowWeigherModal = () => {
		// Pulse showWeigherModalPulse high to open modal
		setShowWeigherModalPulse(true);
		setTimeout(resetShowWeigherModalPulse, 1000); //turn off after 1 sec. only needs a pulse to open then all controls are handled by the component
	};

	return (
		<>
			<CheckAuth groupName={'admin'} />
			<Header>
				<BC trail='[["Home", "/"], ["Session management", ""]]' />
			</Header>
			<Container fluid className="body">
				<Row>
					<Col>
						<Form onSubmit={handleSubmit}>
							<Card body>
								<Card.Title>Manage Sessions</Card.Title>
								<Card.Body>
									<ClientSessionSelect
										layout="filtered-list"
										showOpenSessionsOnly={showOpenSessionsOnly}
										handleBeforeSessionChange={() => {}}
										hideSessionSelect={true}
										includeYardWeights={true}
										lock={false}
									>
										<Row className="inputRow">
											<Col sm="3"></Col>
											<Col sm="9">
												<Button
													variant="outline-primary"
													onClick={handleShowWeigherModal}
													size="sm"
													title={'Edit weighers'}
												>
													<AiOutlineEdit size={'20'} /> Edit Weighers
												</Button>
											</Col>
										</Row>
										<Weigher
											setWeigherId={() => {}}
											showPulse={showWeigherModalPulse}
											clientId={clientId || null}
										/>
									</ClientSessionSelect>
								</Card.Body>
							</Card>

							<Card body>
								<Card.Body className="filteredSessionListCard">
									{/* <div style={{float: 'left', clear: 'both'}}> */}
									<Button
										size="sm"
										variant="outline-primary"
										disabled={false}
										onClick={() => handleNewSessionController()}
										title={'start new session'}
										{...(addingNewSession && { disabled: true })}
									>
										<AiFillPlusCircle size={'32'} /> New session
									</Button>
									<ShowOpenSessionsOnly
										//cols = { {lhs:3, rhs:9} }
										cols={{ lhs: 0, rhs: 12 }}
										value={showOpenSessionsOnly}
										controlStyle={controlStyle}
										setShowOpenSessionsOnly={setShowOpenSessionsOnly}
									/>

									{/* </div> */}

									<SessionFilteredList
										//handleFilteredChange = { handleFilteredChange }
										handleSessionEditBtn={handleSessionEditBtn}
										handleSessionCloseBtn={handleSessionCloseBtn}
										sessionIds={sessionIds}
										msessionId={msessionId}
										showOpenSessionsOnly={showOpenSessionsOnly}
										lock={false}
									/>
									<SessionChangeModal {...props} />
								</Card.Body>
							</Card>
						</Form>
					</Col>
				</Row>
			</Container>
			<Container fluid>
				<Row>
					<Col sm="12">
						<Footer />
					</Col>
				</Row>
			</Container>
		</>
	);
};
